<button mat-icon-button (click)="openUserEmail()" tabindex="-1">
  <mat-icon> email </mat-icon>
</button>
